import Vue from "vue";
import Router from "vue-router";
import module from "./module";
import Index from "@views/home/Index";
import Search from "@views/shop/GoodSearch";
import Category from "@views/shop/GoodsClass";
import ShoppingCart from "@views/shop/ShoppingCart";
import GoodsList from "@views/shop/GoodsList";
import NewGoodsList from "@views/shop/NewGoodsList"
import zqindex from "@views/home/zqIndex"
import NotDefined from "@views/NotDefined";
import $store from "../store";
import toLogin, { toBindCoupon, toLoginPhone } from "@libs/login";
import {  checkLogin } from "@api/public";
import Loading from "@views/Loading";
import cookie from "@utils/store/cookie";
import { isWeixin } from "@utils/index";

Vue.use(Router);

const router = new Router({
  mode: "history",
  // base:'/zx',
  routes: [
    {
      path: "/",
      name: "Index",
      meta: {
        title: "首页",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff",
        auth: true,
        home: false
      },
      component: Index
    },
    {
      path: '/zqindex',
      name: "zqindex",
      meta: {
        title: "专区首页",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff",
        auth: true,
        home: false
      },
      component: zqindex
    },
    {
      path: "/customer/chat/:id/:productId?",
      name: "CustomerService",
      meta: {
        title: "客服聊天",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/user/CustomerService.vue")
    },
    {
      path: "/category/:pid?",
      name: "GoodsClass",
      meta: {
        title: "产品分类",
        keepAlive: true,
        footer: true,
        auth: true,
        home: false,
        backgroundColor: "#fff"
      },
      component: Category
    },
    {
      path: "/collection",
      name: "GoodsCollection",
      meta: {
        title: "收藏商品",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/shop/GoodsCollection.vue")
    },
    {
      path: "/search",
      name: "GoodSearch",
      meta: {
        title: "搜索商品",
        keepAlive: true,
        backgroundColor: "#fff"
      },
      component: Search
    },
    {
      path: "/news_detail/:id",
      name: "NewsDetail",
      meta: {
        title: "新闻详情",
        keepAlive: true,
        backgroundColor: "#fff"
      },
      component: () => import("@views/shop/news/NewsDetail.vue")
    },
    {
      path: "/news_list",
      name: "NewsList",
      meta: {
        title: "新闻",
        keepAlive: true,
        backgroundColor: "#fff"
      },
      component: () => import("@views/shop/news/NewsList.vue")
    },
    {
      path: "/evaluate_list/:id",
      name: "EvaluateList",
      meta: {
        title: "商品评分",
        keepAlive: true,
        auth: true
      },
      component: () => import("@views/shop/EvaluateList.vue")
    },
    {
      path: "/goods_evaluate/:id",
      name: "GoodsEvaluate",
      meta: {
        title: "商品评价",
        keepAlive: true,
        auth: true
      },
      component: () => import("@views/shop/GoodsEvaluate.vue")
    },
    {
      path: "/promotion",
      name: "GoodsPromotion",
      meta: {
        title: "促销单品",
        keepAlive: false
      },
      component: () => import("@views/shop/GoodsPromotion.vue")
    },
    {
      path: "/hot_new_goods/:type",
      name: "HotNewGoods",
      meta: {
        title: "热门榜单",
        keepAlive: false
      },
      component: () => import("@views/shop/HotNewGoods.vue")
    },
    {
      path: "/detail/:id",
      name: "GoodsCon",
      meta: {
        title: "商品详情",
        keepAlive: false,
        auth: true,
        home: false
      },
      component: () => import("@views/shop/GoodsCon.vue")
    },
    {
      path: "/shop/storeList/:gonames?",
      name: "StoreList",
      meta: {
        title: "门店列表",
        keepAlive: false
      },
      component: () => import("@views/shop/StoreList.vue")
    },
    {
      path: "/cart",
      name: "ShoppingCart",
      meta: {
        title: "购物车",
        keepAlive: true,
        footer: true,
        auth: true,
        home: false
      },
      component: ShoppingCart
    },
    {
      path: "/goods_list",
      name: "GoodsList",
      meta: {
        title: "商品列表",
        keepAlive: true,
        home: false
      },
      component: GoodsList
    },
    {
      path: '/newGoods_list',
      name: 'NewGoodsList',
      meta: {
        title: '商品列表',
        keepAlive: true,
        home: false
      },
      component: NewGoodsList
    },
    {
      path: "/register",
      name: "Register",
      meta: {
        title: "注册",
        keepAlive: true
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/Register.vue")
    },
    {
      path: "/change_password",
      name: "ChangePassword",
      meta: {
        title: "修改密码",
        keepAlive: true,
        backgroundColor: "#fff",
        auth: true
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/ChangePassword.vue")
    },
    {
      path: "/retrieve_password",
      name: "RetrievePassword",
      meta: {
        title: "找回密码",
        keepAlive: true
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/RetrievePassword.vue")
    },
    {
      path: "/login",
      name: "Login",
      meta: {
        title: "登录",
        keepAlive: true,
        home: false,
        backgroundColor: "#fff"
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/Login.vue")
    },
    //扫码登录
    {
      path: '/scanCode',
      name: 'scanCode',
      meta: {
        title: '小将商城',
        keepAlive: true,
        home: false,
        auth: false,
        backgroundColor: "#fff"
      },
      component: () =>
        import(/* webpackChunkName: "scanCode" */ "@views/user/scanCode.vue")
    },
    //用户协议
    {
      path: '/userNotice',
      name: 'userNotice',
      meta: {
        title: '小将商城',
        keepAlive: true,
        home: false,
        backgroundColor: "#fff"
      },
      component: () =>
        import(/* webpackChunkName: "scanCode" */ "@views/user/usernotice/purchaseNotes.vue")
    },
    {
      path: '/index_hot',
      name: 'indexHot',
      meta: {
        title: '热门商品',
        keepAlive: true,
        home: true,
        backgroundColor: '#fff'
      },
      component: () => import(/* webpackChunkName: "indexHot" */ "@views/home/index_hot.vue")
    },
    ...module,
    {
      path: "/auth/:url",
      name: "Loading",
      meta: {
        title: " 加载中",
        keepAlive: false
      },
      component: Loading
    },
    {
      path: "*",
      name: "NotDefined",
      meta: {
        title: "页面找不到",
        keepAlive: true,
        home: false,
        backgroundColor: "#F4F6FB"
      },
      component: NotDefined
    }, {
      path: "/notWechat",
      name: "NotWechat",
      meta: {
        title: "h5",
        keepAlive: false,
        home: false,
        auth: false,
        backgroundColor: "#fff"
      },
      component: () => import("@views/NotWechat.vue")
    }
  ],
  scrollBehavior(to, from) {
    from.meta.scrollTop = window.scrollY;
    return { x: 0, y: to.meta.scrollTop || 0 };
  }
});

const { back, replace } = router;

router.back = function () {
  this.isBack = true;
  back.call(router);
};
router.replace = function (...args) {
  this.isReplace = true;
  replace.call(router, ...args);
};

router.beforeEach((to, form, next) => {
  const { title, backgroundColor, footer, movieFooter, festivalFooter, bookFooter, home, auth } = to.meta;

  // console.log('to=',to.name,'form=',form.name,"路由******");

  document.title = title || process.env.VUE_APP_NAME || "crmeb商城";
  //判断是否显示底部导航
  footer === true ? $store.commit("SHOW_FOOTER") : $store.commit("HIDE_FOOTER");

  //判断是否显示电影底部导航
  movieFooter === true ? $store.commit("SHOW_MOVIEFOOTER") : $store.commit("HIDE_MOVIEFOOTER");

  //判断是否显示节日专区底部导航
  festivalFooter === true ? $store.commit("SHOW_FESTIVALFOOTER") : $store.commit("HIDE_FESTIVALFOOTER");

  //判断是否显示书城底部导航
  bookFooter === true ? $store.commit("SHOW_BOOKFOOTER") : $store.commit("HIDE_BOOKFOOTER");

  //控制悬浮按钮是否显示
  home === false ? $store.commit("HIDE_HOME") : $store.commit("SHOW_HOME");

  $store.commit("BACKGROUND_COLOR", backgroundColor || "#F5F5F5");

  // if (!isWeixin()) {
  //   if (to.name == 'NotWechat') {
  //     next();
  //     return;
  //   } else {
  //     next('/notWechat');
  //     return;
  //   }
  // }

  // if (auth === true && !$store.state.app.token) {
  if (auth === true && !localStorage.getItem("LOGIN")) {
   
    if (to.name === 'BindCoupon') {
      next();
      return;
    };

    if (form.name === "Login") {
      return;
    }
    return toLogin(true, to.fullPath);
  }
//判断token是否有效 无效从新授权
if (auth===true ) {
  let dataApi = localStorage.getItem('LOGIN')
  checkLogin({ token: dataApi }).then(res => {
    // alert(res.data.token+"路由打印")
    if (res.data.token==0) {
      let token=''
      localStorage.setItem('LOGIN',token)
      return toLogin()  
    }
  })
}

  // if (!localStorage.getItem("LOGIN") || !$store.state.app.token) {
  //   if (form.name === 'Index') {
  //     return toLogin(true, to.fullPath);
  //   }
  // }

  //手机号
  //微信登录

  if (auth === true && !cookie.get('isbind') && $store.state.app.token) {
    if (to.name === 'BindCoupon') {
      next();
      return;
    }

    if (to.name === "Login") {
      next();
      return;
    }

    if (to.path.indexOf('/festival') !== -1) {
      next();
      return;
    }

    if (to.path.indexOf('/scanCode') !== -1) {
      next();
      return;
    }

    if (form.name === "Login") return;
    return toLoginPhone(to.fullPath);
  }

  if (auth) {
    $store.dispatch("USERINFO").then(() => {
      next();
    });
  } else next();
});

//  解决 Vue 重复点击相同路由，出现报错 Uncaught (in promise) NavigationDuplicated: Avoided redundant navigation 问题
const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
}
const VueRouterReplace = Router.prototype.replace;
Router.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch(err => err);
}
export default router;
